import actions from '../../actionTypes';

export default (token, refreshToken, expiresIn, scope) => {
  return {
    type: actions.LOGGED_IN,
    token,
    refreshToken,
    expiresIn,
    scope
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/loggedIn.js